<template lang="pug">
  v-app
    .wwww
      v-progress-linear(:active="show", v-model="value" height="2", color="white")
      .enter-inner
        img(src='static/Logo_Stat.svg')
        h3 {{$t('StartPage.registerBlock.startMessageOne')}}#[br] {{$t('StartPage.registerBlock.startMessageTwo')}}
        div.text {{$t('StartPage.registerBlock.enterPageDescr')}}
        p {{$t('StartPage.registerBlock.copyright')}} {{new Date().getFullYear()}}
</template>

<script>
export default {
  name: 'EnterPage',
  data() {
    return {
      value: 0,
      show: true
    }
  },
  mounted() {
    this.setInterval()
  },
  methods: {
    setInterval() {
      setTimeout(() => {
        if (this.value !== 100) {
          this.value += 5
          this.setInterval()
        } else {
          this.show = false
          this.$router.push({ name: 'login' })
        }
      }, 150)
    }
  }
}
</script>

<style lang="scss">
.wwww {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: url('/static/background.jpg') center center no-repeat;
}
.application {
  .v-progress-linear {
    position: fixed;
    top: 0;
    margin: 0;
  }
  .enter {
    &-inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      img {
        max-width: 230px;
        width: 100%;
        margin-bottom: 25px;
      }
      h3 {
        font-family: 'Open Sans', sans-serif;
        text-transform: uppercase;
        color: #fff;
        font-size: 32px;
        line-height: 1.2;
        text-align: center;
        font-weight: 700;
        margin-bottom: 8px;
      }
      .text {
        max-width: 660px;
        width: 100%;
        color: white;
        font-size: 14px;
        font-weight: 400;
      }
      p {
        position: absolute;
        bottom: 50px;
        left: 0;
        right: 0;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EnterPage/index.vue